
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learning-programs",
      function () {
        return require("private-next-pages/learning-programs/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learning-programs"])
      });
    }
  